import React from 'react';
import { Autocomplete, TextField, Box, Typography } from '@mui/material';
import LocalHospital from '@mui/icons-material/LocalHospital';
import { useUnidade, Unidade } from '../contexts/UnidadeContext';
import { useAuth } from '../contexts/AuthContext';

/**
 * Seletor "Unidade de Saude" — renderizado no menu lateral, logo abaixo do
 * seletor de Municipio. Default vazio (= Todas as unidades). Quando uma unidade
 * e selecionada, as telas do /saude filtram por ela (via UnidadeContext).
 * Aparece para TODOS os municipios com municipio ativo, mesmo sem unidades
 * cadastradas na tabela (lista vazia => apenas "Todas as unidades").
 */
const UnidadeSaudeSelector: React.FC = () => {
  const { municipioAtivo } = useAuth();
  const { unidades, unidadeSelecionada, setUnidadeSelecionada, loading } = useUnidade();

  // So depende de haver um municipio ativo (nao do numero de unidades)
  if (!municipioAtivo) return null;

  return (
    <Box sx={{ mx: 1.5, mb: 0.5, px: 1.5, py: 1, borderRadius: '8px', backgroundColor: 'rgba(16,185,129,0.10)', border: '1px solid rgba(16,185,129,0.25)', flexShrink: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <LocalHospital sx={{ fontSize: 14, color: '#34d399' }} />
        <Typography sx={{ fontSize: '0.625rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', color: '#94a3b8', lineHeight: 1.2 }}>
          Unidade de Saude
        </Typography>
      </Box>
      <Autocomplete
        size="small"
        options={unidades}
        value={unidadeSelecionada}
        loading={loading}
        onChange={(_e, value: Unidade | null) => setUnidadeSelecionada(value)}
        getOptionLabel={(o) => o?.nome || ''}
        isOptionEqualToValue={(o, v) => o.codunidade === v.codunidade}
        noOptionsText="Nenhuma unidade"
        loadingText="Carregando..."
        clearText="Todas as unidades"
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Todas as unidades"
            variant="standard"
            InputProps={{ ...params.InputProps, disableUnderline: true }}
          />
        )}
        sx={{
          '& .MuiInputBase-root': { fontSize: '0.8125rem', color: 'white', p: '0 !important' },
          '& .MuiInputBase-input': { color: 'white', p: '2px 0 !important' },
          '& .MuiInputBase-input::placeholder': { color: '#cbd5e1', opacity: 1 },
          '& .MuiSvgIcon-root': { color: '#94a3b8' },
        }}
      />
    </Box>
  );
};

export default UnidadeSaudeSelector;
